// Lexical theme slots mapped to Tailwind class strings. Lexical writes these
// onto the nodes it renders, which is why the editor needs no stylesheet of
// its own. Colours go through the --color-* tokens so dark mode follows the
// [data-theme="dark"] switch without a variant.
const editorTheme = {
  paragraph: "tw:mb-2 tw:last:mb-0",
  heading: {
    h1: "tw:font-heading tw:text-2xl tw:font-semibold tw:mt-4 tw:mb-2",
    h2: "tw:font-heading tw:text-xl tw:font-semibold tw:mt-3 tw:mb-2",
    h3: "tw:font-heading tw:text-lg tw:font-semibold tw:mt-3 tw:mb-1",
    h4: "tw:font-heading tw:text-base tw:font-semibold tw:mt-2 tw:mb-1",
    h5: "tw:font-heading tw:text-sm tw:font-semibold tw:mt-2 tw:mb-1",
    h6: "tw:font-heading tw:text-sm tw:font-medium tw:mt-2 tw:mb-1",
  },
  quote:
    "tw:my-2 tw:border-l-4 tw:border-[var(--color-border)] tw:pl-4 tw:italic tw:text-[var(--color-text-secondary)]",
  list: {
    ul: "tw:my-2 tw:list-disc tw:pl-6",
    ol: "tw:my-2 tw:list-decimal tw:pl-6",
    listitem: "tw:my-0.5",
    nested: {
      // The wrapper <li> that holds a nested list must not draw its own
      // marker next to the sublist.
      listitem: "tw:list-none",
    },
  },
  link: "tw:cursor-pointer tw:text-[var(--color-link)]! tw:underline tw:underline-offset-2",
  text: {
    bold: "tw:font-semibold",
    italic: "tw:italic",
    underline: "tw:underline tw:underline-offset-2",
    strikethrough: "tw:line-through",
    underlineStrikethrough:
      "tw:underline tw:line-through tw:underline-offset-2",
    code: "tw:rounded tw:bg-[var(--color-warm-gray-light)] tw:px-1 tw:py-0.5 tw:font-mono tw:text-sm",
  },
  code: "tw:my-2 tw:block tw:overflow-x-auto tw:rounded tw:bg-[var(--color-warm-gray-light)] tw:p-4 tw:font-mono tw:text-sm tw:whitespace-pre-wrap",
  mention:
    "tw:rounded tw:bg-[color-mix(in_srgb,var(--color-highlight)_18%,transparent)] tw:px-1 tw:text-[var(--color-highlight)]",
};

export default editorTheme;
